import { PATHS } from './page-paths';

export const APP_CONFIG = {
  appName: '3D Printing Support',
  authenticatedEntryPath: PATHS.CHAT,
  unAuthenticatedEntryPath: PATHS.SIGN_IN,
  REDIRECT_URL_KEY: 'redirectPath',
};

export const translationLanguages = [
  { name: 'English', symbol: 'EN', code: 'en' },
  { name: 'Hindi', symbol: 'हिन्दी', code: 'hi' },
  { name: 'Marathi', symbol: 'मराठी', code: 'mr' },
];
